import { Box } from '@mui/material';
import { CustomButton } from '../../../../../../../Infra/CustomButton/CustomButton';
import { useRuleBuilder } from './useRuleBuilder';
import { RuleBuilderProps } from './types';
import { RuleRow } from './components/RuleRow/RuleRow';
import './RuleBuilder.scss';

export const RuleBuilder = (props: RuleBuilderProps) => {
  const { rules, handleAddRule, handleRemoveRule } = useRuleBuilder(props);

  return (
    <Box className="ruleBuilder">
      <Box className="rulesList">
        {rules.map((rule, index) => (
          <RuleRow
            key={rule.id}
            rule={rule}
            ruleNumber={index + 1}
            templateId={props.templateId}
            instrumentType={props.instrumentType}
            sectionId={props.sectionId}
            categoryId={props.categoryId}
            availableHeaders={props.availableHeaders || []}
            onRemove={() => handleRemoveRule(rule.id)}
            isFirstRule={index === 0}
          />
        ))}
      </Box>

      <CustomButton
        variant="contained"
        color="primary"
        onClick={handleAddRule}
        className="addRuleButton"
      >
        ADD RULE
      </CustomButton>
    </Box>
  );
};
